class ProductConfigurator {
  constructor(element) {
    this.element = element;
    if (!this.element) return;

    this.options = JSON.parse(this.element.dataset.productConfigurator);
    this.storageKey = `configurator-personalization-${this.options.configuratorSku}`;

    this.trigger = this.element.querySelector('[data-product-configurator-trigger]');
    this.triggerText = this.element.querySelector('[data-product-configurator-trigger-text]');
    this.triggerTextEdit = this.element.querySelector('[data-product-configurator-trigger-text-edit]');
    this.removePersonalizationButton = this.element.querySelector('#product-configurator-remove-personalization-button');
    this.showPersonalizationButton = this.element.querySelector('#product-configurator-show-personalization-button');
    this.personalizationInput = this.element.querySelector('[data-product-configurator-personalization-input]');
    this.message = this.element.querySelector('[data-product-configurator-message]');
    this.overlay = null;
    this.pdfOverlay = null;
    this.addToCartButton = this.element.querySelector('[name="add"]');


    this.configuratorSku = this.options.configuratorSku;
    this.configuratorLanguage = this.options.configuratorLanguage;

    // this.src = `https://kambukkapersonalizer-dd70ff48ed4a.deltablue.io/?sku=${this.configuratorSku}&lang=${this.configuratorLanguage}&ui=true`;
    this.src = `https://configurator.kambukka.com/?sku=${this.configuratorSku}&l=${this.configuratorLanguage}&ui=true`;

    if (this.trigger) {
      this.init();
    }
  }

  onFormSubmit() {
    // This function is triggered when the form submits. 
    // We now handle the clearing of personalization via a click listener on the add-to-cart button
    // to ensure the data is submitted before being cleared.
  }

  init() {
    this.checkForPendingPersonalization();
    this.loadPersonalization();

    if (this.personalizationInput && !this.personalizationInput.value) {
      this.personalizationInput.name = '';
    }

    this.updateButtonStates();

    if (this.trigger) {
      this.trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.openConfigurator();
      });
    }

    if (this.removePersonalizationButton) {
      this.removePersonalizationButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.removePersonalization();
      });
    }

    if (this.showPersonalizationButton) {
      this.showPersonalizationButton.addEventListener('click', (e) => {
        e.preventDefault();
        this.displayPersonalizationPdf();
      });
    }

    window.addEventListener('message', this.handleMessage.bind(this));

    if (this.addToCartButton) {
      this.addToCartButton.addEventListener('click', () => {
        // After the user clicks 'Add to Cart', we wait briefly for the form to capture the data,
        // then we clear the personalization from the session.
        setTimeout(() => {
          this.clearLocalState();
          this.resetRemoteConfigurator();
        }, 200); // Increased timeout slightly for reliability
      });
    }

  }

  checkForPendingPersonalization() {
    const pendingData = sessionStorage.getItem('pending-personalization-redirect');
    if (pendingData) {
      try {
        const pending = JSON.parse(pendingData);
        const timeDiff = Date.now() - pending.timestamp;
        
        if (timeDiff < 30000 && pending.targetSku === this.configuratorSku) {
          this.savePersonalization(pending.personalizationData);
          sessionStorage.removeItem('pending-personalization-redirect');
          console.log('Applied pending personalization for SKU:', this.configuratorSku);
        } else if (timeDiff >= 30000) {
          sessionStorage.removeItem('pending-personalization-redirect');
        }
      } catch (error) {
        console.error('Error processing pending personalization:', error);
        sessionStorage.removeItem('pending-personalization-redirect');
      }
    }
  }

  openConfigurator() {
    this.overlay = document.createElement('div');
    this.overlay.style.position = 'fixed';
    this.overlay.style.top = '0';
    this.overlay.style.left = '0';
    this.overlay.style.width = '100%';
    this.overlay.style.height = '100%';
    this.overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
    this.overlay.style.zIndex = '10000';
    this.overlay.style.display = 'flex';
    this.overlay.style.alignItems = 'center';
    this.overlay.style.justifyContent = 'center';

    const closeButton = document.createElement('button');
    closeButton.textContent = '×';
    closeButton.style.position = 'absolute';
    closeButton.style.top = '20px';
    closeButton.style.right = '20px';
    closeButton.style.fontSize = '30px';
    closeButton.style.color = 'white';
    closeButton.style.background = 'transparent';
    closeButton.style.border = 'none';
    closeButton.style.cursor = 'pointer';
    closeButton.addEventListener('click', this.closeConfigurator.bind(this));

    const iframeContainer = document.createElement('div');
    iframeContainer.style.position = 'relative';
    iframeContainer.style.width = '90%';
    iframeContainer.style.height = '90%';
    iframeContainer.style.backgroundColor = 'white';

    const iframe = document.createElement('iframe');
    iframe.src = this.src;
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.border = 'none';

    iframeContainer.appendChild(iframe);
    this.overlay.appendChild(closeButton);
    this.overlay.appendChild(iframeContainer);
    document.body.appendChild(this.overlay);
    document.body.style.overflow = 'hidden';
  }

  closeConfigurator() {
    if (this.overlay) {
      document.body.removeChild(this.overlay);
      this.overlay = null;
      // Only restore body overflow if the PDF overlay is also closed
      if (!this.pdfOverlay) {
        document.body.style.overflow = 'auto';
      }
    }
  }

  handleMessage(event) {
    let data;
    if (typeof event.data === 'string') {
      try {
        data = JSON.parse(event.data);
      } catch (e) {
        return;
      }
    } else if (typeof event.data === 'object') {
      data = event.data;
    } else {
      return;
    }

    if (data && data.loaded === true) {
    } else if (data && data.personalized && data.sku) {
      if (data.sku !== this.configuratorSku) {
        this.handleSkuDeviation(data);
      } else {
        this.savePersonalization(data);
        this.closeConfigurator();
      }
    } else if (data && data.cancelled === true) {
      this.removePersonalization();
      this.clearLocalState();

      this._selectPersonalizationVariant('No Print');
    }
  }

  savePersonalization(personalizationData) {
    const dataString = JSON.stringify(personalizationData);
    sessionStorage.setItem(this.storageKey, dataString);
    if (this.personalizationInput) {
      this.personalizationInput.name = 'properties[_personalization]';
      this.personalizationInput.value = dataString;
    }

    this.updateButtonStates();
    this._selectPersonalizationVariant(personalizationData.personalized);
  }

  loadPersonalization() {
    const savedData = sessionStorage.getItem(this.storageKey);
    if (savedData && this.personalizationInput) {
      this.personalizationInput.value = savedData;
      this.updateUIAfterSave();
    }
  }

  updateUIAfterSave() {
    // This method's original UI update logic is now primarily handled by updateButtonStates().
    // It is kept structurally for now but can be reviewed for complete removal
    // if it's confirmed to be fully redundant across all call sites.
  }

  updateButtonStates() {
    const hasPersonalization = this.personalizationInput && this.personalizationInput.value;

    if (this.triggerText && this.triggerTextEdit) {
      this.triggerText.classList.toggle('hidden', hasPersonalization);
      this.triggerTextEdit.classList.toggle('hidden', !hasPersonalization);
    }

    if (this.removePersonalizationButton) {
      this.removePersonalizationButton.classList.toggle('hidden', !hasPersonalization);
    }

    if (this.showPersonalizationButton) {
      this.showPersonalizationButton.style.display = hasPersonalization ? 'inline-flex' : 'none';
    }

    if (this.message) {
      if (hasPersonalization) {
        this.message.textContent = this.options.personalizedText || 'Personalized';
      } else {
        this.message.textContent = '';
      }
    }
  }

  _selectPersonalizationVariant(valueToSelect) {
    const normalizedValue = (valueToSelect || 'no print').toLowerCase();

    const fieldsets = document.querySelectorAll('.product-form__input');
    let personalizationFieldset = null;

    for (const fieldset of fieldsets) {
      const legend = fieldset.querySelector('.form__label');
      if (legend && legend.textContent.trim() === 'Personalization') {
        personalizationFieldset = fieldset;

        break;
      }
    }

    if (personalizationFieldset) {
      const radioButtons = personalizationFieldset.querySelectorAll('input[type="radio"]');
      let targetRadio = null;

      for (const radio of radioButtons) {
        if (radio.value.toLowerCase() === normalizedValue) {
          targetRadio = radio;
          break;
        }
      }

      // Fallback for 'no print' if the specific value isn't found
      if (!targetRadio && normalizedValue !== 'no print') {
        for (const radio of radioButtons) {
          if (radio.value.toLowerCase() === 'no print') {
            targetRadio = radio;
            break;
          }
        }
      }

      if (targetRadio) {
        targetRadio.checked = true;
        targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        console.warn(`ProductConfigurator: Could not find a matching radio button for '${normalizedValue}'.`);
      }
    } else {
      console.warn(`ProductConfigurator: Could not find fieldset for 'Personalization' option.`);
    }
  }

  clearLocalState() {
    sessionStorage.removeItem(this.storageKey);
    if (this.personalizationInput) {
      this.personalizationInput.value = '';
      this.personalizationInput.name = '';
    }
    this.updateButtonStates();
    this._selectPersonalizationVariant('No Print');
  }

  resetRemoteConfigurator() {
    if (!this.src) return;
    fetch(this.src, {
      method: 'POST',
      mode: 'no-cors',
      body: JSON.stringify({ 'clear': 'true' }),
    }).catch(error => {
      console.error('ProductConfigurator: Fetch error during remote reset:', error);
    });
  }

  displayPersonalizationPdf() {
    if (!this.personalizationInput || !this.personalizationInput.value) {
      console.warn('ProductConfigurator: No personalization data found to display.');
      return;
    }

    try {
      const personalizationData = JSON.parse(this.personalizationInput.value);
      if (personalizationData && personalizationData.url) {
        this.openPdfInOverlay(personalizationData.url);
      } else {
        console.warn('ProductConfigurator: Personalization data does not contain a URL.', personalizationData);
      }
    } catch (error) {
      console.error('ProductConfigurator: Error parsing personalization data:', error, this.personalizationInput.value);
    }
  }

  openPdfInOverlay(pdfUrl) {
    if (this.pdfOverlay) this.closePdfOverlay(); // Close if already open

    this.pdfOverlay = document.createElement('div');
    this.pdfOverlay.style.position = 'fixed';
    this.pdfOverlay.style.top = '0';
    this.pdfOverlay.style.left = '0';
    this.pdfOverlay.style.width = '100%';
    this.pdfOverlay.style.height = '100%';
    this.pdfOverlay.style.backgroundColor = 'rgba(0, 0, 0, 0.8)';
    this.pdfOverlay.style.zIndex = '10001'; // Ensure it's above configurator overlay if both could exist
    this.pdfOverlay.style.display = 'flex';
    this.pdfOverlay.style.alignItems = 'center';
    this.pdfOverlay.style.justifyContent = 'center';

    const closeButton = document.createElement('button');
    closeButton.textContent = '×';
    closeButton.style.position = 'absolute';
    closeButton.style.top = '20px';
    closeButton.style.right = '20px';
    closeButton.style.fontSize = '30px';
    closeButton.style.color = 'white';
    closeButton.style.background = 'transparent';
    closeButton.style.border = 'none';
    closeButton.style.cursor = 'pointer';
    closeButton.setAttribute('aria-label', 'Close PDF viewer');
    closeButton.addEventListener('click', this.closePdfOverlay.bind(this));

    const iframeContainer = document.createElement('div');
    iframeContainer.style.position = 'relative';
    iframeContainer.style.width = '90%';
    iframeContainer.style.height = '90%';
    iframeContainer.style.backgroundColor = 'white'; // Or transparent if PDF viewer handles it

    const iframe = document.createElement('iframe');
    iframe.src = pdfUrl;
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.border = 'none';
    iframe.title = 'Personalization PDF Viewer';

    iframeContainer.appendChild(iframe);
    this.pdfOverlay.appendChild(closeButton);
    this.pdfOverlay.appendChild(iframeContainer);
    document.body.appendChild(this.pdfOverlay);
    document.body.style.overflow = 'hidden';
  }

  closePdfOverlay() {
    if (this.pdfOverlay) {
      document.body.removeChild(this.pdfOverlay);
      this.pdfOverlay = null;
      // Only restore body overflow if the main configurator overlay is also closed
      if (!this.overlay) {
        document.body.style.overflow = 'auto';
      }
    }
  }

  removePersonalization() {
    const initialHref = window.location.href;

    // 1. Trigger the local and remote state clearing.
    // This will select the 'No Print' variant and start the theme's update process.
    this.clearLocalState();
    this.resetRemoteConfigurator();

    // 2. Poll for the URL to change, which is the most reliable signal that the variant update is complete.
    const maxPollTime = 2000; // 2 seconds
    const pollInterval = 50; // 50ms
    let elapsedTime = 0;

    const pollForUrlChange = setInterval(() => {
      elapsedTime += pollInterval;

      // If the URL has changed, the theme has updated the variant. We can now safely reload.
      if (window.location.href !== initialHref) {
        clearInterval(pollForUrlChange);
        window.location.reload();
        return;
      }

      // As a fallback, if we've waited too long, reload anyway to prevent getting stuck.
      if (elapsedTime >= maxPollTime) {
        clearInterval(pollForUrlChange);
        window.location.reload();
      }
    }, pollInterval);
  }

  handleSkuDeviation(data) {
    const targetSku = data.sku;
    const targetStorageKey = `configurator-personalization-${targetSku}`;
    
    sessionStorage.setItem(targetStorageKey, JSON.stringify(data));
    sessionStorage.setItem('pending-personalization-redirect', JSON.stringify({
      targetSku: targetSku,
      personalizationData: data,
      timestamp: Date.now()
    }));
    
    this.redirectToVariantBySku(targetSku);
  }

  redirectToVariantBySku(targetSku) {
    const ajaxUrl = `${window.location.origin}/collections/all/products.json`;

    console.log('Redirecting to SKU:', targetSku);

    this.fetchAndFindProductBySku(ajaxUrl, targetSku);
  }

  async fetchAndFindProductBySku(baseUrl, targetSku) {
    let page = 1;
    const maxPages = 20; // Safety limit to prevent infinite loops
    
    while (page <= maxPages) {
      try {
        const ajaxUrl = `${baseUrl}?page=${page}`;
        const response = await fetch(ajaxUrl);
        const data = await response.json();
        
        // If no products on this page, we've reached the end
        if (!data || !data.products || data.products.length === 0) {
          break;
        }
        
        // Check if the target SKU is in this page's products
        const targetProduct = data.products.find(product =>
          product.variants.some(variant => variant.sku === targetSku)
        );
        
        // If found, redirect immediately
        if (targetProduct && targetProduct.handle) {
          console.log(targetProduct);
          console.log('Found product with SKU:', targetSku, 'on page', page);
          window.location.href = `/products/${targetProduct.handle}`;
          return;
        }
        
        // SKU not found on this page, try next page
        page++;
        
      } catch (error) {
        console.error('Error fetching products from page', page, ':', error);
        break;
      }
    }
    
    // SKU not found after checking all pages
    console.error('No product found with SKU:', targetSku);
    this.fallbackToCurrentProduct();
  }

  fallbackToCurrentProduct() {
    this.savePersonalization(JSON.parse(sessionStorage.getItem('pending-personalization-redirect')).personalizationData);
    this.closeConfigurator();
    sessionStorage.removeItem('pending-personalization-redirect');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const configuratorElement = document.querySelector('[data-product-configurator]');
  if (configuratorElement) {
    new ProductConfigurator(configuratorElement);
  }
});
